import type { ReactPerformance } from "@/lib/react_performance"

export const isUpdateSignal = <State extends Record<string, unknown>>(
  subject: State | ReactPerformance.Update<State>
): subject is ReactPerformance.UpdateSignal => {
  if (Object.hasOwn(subject, `update`)) {
    return (subject as { update: unknown }).update === true
  }

  return false
}
